import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppThunkAPIType } from "../../app/appTypes"
import { getWithAuth } from "../../http"

export interface Producer {
    id: string
    shortName: string
    name: string
}

export const loadProducers = createAsyncThunk<Producer[], void, AppThunkAPIType>("producers/load", async (_, { dispatch, rejectWithValue }) => {
    const result = await dispatch(getWithAuth({
        url: `api/producers`,
    }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as Producer[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})
